import { CurrencyEnum } from '../interfaces/plan.interface';
import { SUPPORTED_CURRENCIES } from '../config/currencies';

/**
 * Format a number as currency with the appropriate symbol
 */
export const formatCurrencyAmount = (
  amount: number | string,
  currency: CurrencyEnum = CurrencyEnum.USD,
  fallbackSymbol: string = '$'
): string => {
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) || 0 : amount || 0;
  const currencyConfig = SUPPORTED_CURRENCIES[currency];
  const symbol = currencyConfig?.symbol || fallbackSymbol;
  
  return `${symbol}${numericAmount.toFixed(2)}`;
};

/**
 * Format currency for order display
 */
export const formatOrderCurrency = (
  amount: number | string,
  orderCurrency?: CurrencyEnum,
  orderCurrencySymbol?: string
): string => {
  // If order has specific currency info, use it
  if (orderCurrency) {
    return formatCurrencyAmount(amount, orderCurrency);
  }
  
  // If order has currency symbol, use it
  if (orderCurrencySymbol) {
    const numericAmount = typeof amount === 'string' ? parseFloat(amount) || 0 : amount || 0;
    return `${orderCurrencySymbol}${numericAmount.toFixed(2)}`;
  }
  
  // Fallback to USD
  return formatCurrencyAmount(amount, CurrencyEnum.USD);
};

/**
 * Get currency symbol for a given currency
 */
export const getCurrencySymbol = (currency: CurrencyEnum): string => {
  const currencyConfig = SUPPORTED_CURRENCIES[currency];
  return currencyConfig?.symbol || '$';
}; 